/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Update_ButtonInputs */



/**
* | output |
* | --- |
* | "Update Issue" |
*
* @param {Manual_Qc_Update_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_update_button = /** @type {((inputs?: Manual_Qc_Update_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Update_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mettre a jour l'incident")
	if (locale === "de") return /** @type {LocalizedString} */ ("Update-Problem")
	if (locale === "it") return /** @type {LocalizedString} */ ("Problema di aggiornamento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновление информации по проблеме")
	if (locale === "es") return /** @type {LocalizedString} */ ("Problema de actualización")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更新问题")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アップデートの問題")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपडेट समस्या")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Problema de atualização")
	return /** @type {LocalizedString} */ ("Update Issue")
});